const RESET_BREAD_CRUMBS = 'reset_bread_crumbs';
const PUSH_BREAD_CRUMBS = 'push_bread_crumbs';

export function resetCrumbs() {
  return {
    type: RESET_BREAD_CRUMBS,
  };
}

export function updateCrumbs(data) {
  return {
    type: PUSH_BREAD_CRUMBS,
    payload: data,
  };
}

const initialState = {
  // 是否准备好展示数据
  canShow: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case RESET_BREAD_CRUMBS:
      return initialState;
    case PUSH_BREAD_CRUMBS:
      return Object.assign({}, state, payload, { canShow: payload.canShow ?? true });
    default:
      return state;
  }
}
